import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './ConfirmModal.module.scss'
import { Button } from 'blaze-ui/Button'

interface Props {
  onConfirmSecondary?: () => void
  onConfirm: () => void
  onCancel?: () => void
  title: string
  cancelText: string
  confirmText: string
  confirmTextSecondary?: string
  prompt: string
}

export const ConfirmModal = ({
  onConfirm,
  onCancel,
  title,
  cancelText,
  confirmText,
  confirmTextSecondary,
  onConfirmSecondary,
  prompt,
}: Props) => {
  const { closeModal } = useModals()

  const handleCancel = () => {
    closeModal()
    if (onCancel) onCancel()
  }

  const handleConfirm = () => {
    closeModal()
    onConfirm()
  }

  return (
    <Modal.Root bodyClassName={Styles.body}>
      <Modal.Header title={title} />
      <Modal.Content>
        <Text>{prompt}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={handleCancel}>
            {cancelText}
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.buttonsContainer}>
            {confirmTextSecondary && onConfirmSecondary && (
              <Button size="lg" variant="secondary" onPress={onConfirmSecondary}>
                {confirmTextSecondary}
              </Button>
            )}
            <Button size="lg" variant="primary" onPress={handleConfirm}>
              {confirmText}
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
